import useInViewport from '../util/useInViewport';

export default class TransitionInView {
  constructor() {
    this.selector = 'has-background-transition';
    this.init();
  }

  init() {
    const blocks = Array.from(document.querySelectorAll(`.${this.selector}`));
    if (!blocks.length) return;
    blocks.forEach((element) => {

      useInViewport(
        element,
        (target) => {
          if (!target.classList.contains('in-view')) {
            this.updateBlockInViewClass(target);
          }
        },
        (target) => { this.updateBlockInViewClass(target); },
        {
          observerOptions: {
            rootMargin: '-50% 0px -50% 0px',
            threshold: 0,
          },
          once: false,
        }
      );

      this.updateBlockInViewClass(element);

      window.addEventListener('scroll', () => {
        this.checkScrollPosition(element);
      });
    });
  }

  updateBlockInViewClass(block) {
    const rect = block.getBoundingClientRect();
    const triggerPoint = 200;

    if (rect.top <= window.innerHeight - triggerPoint && rect.bottom > 0) {
      block.classList.add('in-view');
      return;
    }

    if (rect.bottom < 0) {
      block.classList.remove('in-view');
      return;
    }

    if (rect.top > window.innerHeight) {
      block.classList.remove('in-view');
      return;
    }
  }

  checkScrollPosition(element) {
    console.log('check');
    const rect = element.getBoundingClientRect();
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const elementOffsetTop = window.innerHeight > 0
    ? rect.top + scrollTop - (window.innerHeight / 2)
    : rect.top + scrollTop;

    if (scrollTop >= elementOffsetTop) {
      element.classList.add('in-view');
    } else {
      element.classList.remove('in-view');
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/transitionInView.js